interface Logo {
  url?: string;
}

export default class Customer {
  id = 0;

  addressId?: number;

  firstName = '';

  lastName = '';

  name = '';

  logo?: Logo;
}
